function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M23 4a3 3 0 00-3-3h-4a1 1 0 100 2h4a1 1 0 011 1v4a1 1 0 102 0V4zM23 16a1 1 0 10-2 0v4a1 1 0 01-1 1h-4a1 1 0 100 2h4a3 3 0 003-3v-4zM4 21a1 1 0 01-1-1v-4a1 1 0 10-2 0v4a3 3 0 003 3h4a1 1 0 100-2H4zM1 8a1 1 0 002 0V4a1 1 0 011-1h4a1 1 0 000-2H4a3 3 0 00-3 3v4z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11 6a1 1 0 00-1-1H6a1 1 0 00-1 1v4a1 1 0 001 1h4a1 1 0 001-1V6zM9 7.5a.5.5 0 00-.5-.5h-1a.5.5 0 00-.5.5v1a.5.5 0 00.5.5h1a.5.5 0 00.5-.5v-1zM18 13a1 1 0 011 1v4a1 1 0 01-1 1h-4a1 1 0 01-1-1v-4a1 1 0 011-1h4zm-3 2.5a.5.5 0 01.5-.5h1a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-1z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M14 5a1 1 0 100 2h2.5a.5.5 0 01.5.5V10a1 1 0 102 0V6a1 1 0 00-1-1h-4z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M14 8a1 1 0 00-1 1v1a1 1 0 102 0V9a1 1 0 00-1-1zM6 13a1 1 0 00-1 1v2a1 1 0 102 0v-.5a.5.5 0 01.5-.5H10a1 1 0 100-2H6zM10 17a1 1 0 100 2 1 1 0 000-2z"
});

var SvgQr = function SvgQr(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 800,
    viewBox: "0 0 24 24",
    fill: "#18191F"
  }, props), _ref, _ref2, _ref3, _ref4);
};

export default SvgQr;